import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getMerchantData } from '../actions/auth';

export default function DashboardLayout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
   const firstName = sessionStorage.getItem("name");
   const [merchants, setMerchants] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");

 const isAdmin = sessionStorage.getItem("isAdmin") === "true";

const navigation = [
  { name: "Dashboard", href: "/dashboard", icon: "ri-dashboard-line" },

  // 👉 Admin-only: Dashboard ke turant baad
  ...(isAdmin
    ? [{ name: "Merchant List", href: "/merchant-list", icon: "ri-store-2-line" }]
    : []),

  { name: "Campaign", href: "/campaigns", icon: "ri-megaphone-line" },
  { name: "Customer", href: "/customers", icon: "ri-user-line" },
  { name: "Transaction", href: "/transactions", icon: "ri-exchange-line" },
  { name: "Wallet", href: "/wallet", icon: "ri-wallet-line" },
  { name: "Voucher Template", href: "/vouchers", icon: "ri-coupon-line" },
  { name: "Schema", href: "/schema", icon: "ri-database-line" },
  { name: "Setting", href: "/settings", icon: "ri-settings-line" },
];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.profile-dropdown')) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
    useEffect(() => {
    const saved = sessionStorage.getItem("code");
    if (saved) {
      setSelectedMerchant(saved);
    }
  }, []);
   useEffect(() => {
    if (!isAdmin) return;

    async function fetchMerchants() {
      try {
        const code = sessionStorage.getItem("code");
        const res = await getMerchantData("MER35806788");

        if (res?.message === "success") {
          const list = res.data.merchants || [];
          setMerchants(list);

          const saved = sessionStorage.getItem("code");

          if (saved && list.some(m => m.Code === saved)) {
            setSelectedMerchant(saved);
          } else if (list.length > 0) {
            setSelectedMerchant(list[0].Code);
            sessionStorage.setItem("code", list[0].Code);
          }
        }
      } catch (e) {
        console.log("Merchant API Error:", e);
      }
    }

    fetchMerchants();
  }, [isAdmin]);


  const handleLogout = () => {
     sessionStorage.clear();
    navigate('/login');
  };
   
  const isActiveRoute = (href) =>
    location.pathname === href || location.pathname.startsWith(href + '/');

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 bottom-0 w-64 bg-white shadow-xl border-r border-gray-200 z-40 transform transition-transform duration-300 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200 bg-white">
            <Link to="/dashboard" className="flex items-center gap-3">
              <img
             src="/primexlogo.png" 
              alt="PrimeX Loyalty"
             className="w-25 h-16"
            />
              {/* <span className="text-lg font-semibold text-gray-900">PrimeX</span> */}
            </Link>
            {/* <button
              onClick={() => setIsSidebarOpen(false)}
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <i className="ri-close-line text-xl"></i>
            </button> */}
          </div>

          <nav className="flex-1 px-4 py-6 overflow-y-auto">
            <div className="space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 cursor-pointer group ${
                    isActiveRoute(item.href)
                      ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`}
                >
                  <i
                    className={`${item.icon} text-lg ${
                      isActiveRoute(item.href)
                        ? 'text-white'
                        : 'text-gray-500 group-hover:text-gray-700'
                    }`}
                  ></i>
                  {item.name}
                </Link>
              ))}
            </div>
          </nav>

          {/* Sidebar footer */}
          {/* <div className="p-4 border-t border-gray-200 bg-white">
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">
                  <i className="ri-star-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-900">Pro Plan</p>
                  <p className="text-xs text-gray-600">Unlimited access</p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 lg:pl-64">
        <div className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-30">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6">
            {/* <button
              onClick={() => setIsSidebarOpen(true)}
              className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <i className="ri-menu-line text-xl"></i>
            </button> */}

            {/* Search */}
            <div className="hidden md:block max-w-md mx-4 flex-1">
              {/* <div className="relative w-full">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
                <input
                  type="text"
                  placeholder="Search anything..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 text-sm bg-gray-50"
                />
              </div> */}
            </div>

            {/* Right side */}
            <div className="flex items-center gap-3">
              {/* <button className="relative w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                <i className="ri-notification-line text-xl"></i>
                <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              </button> */}

              {/* Profile dropdown */}
               {isAdmin && (
               <div className="flex items-center gap-3">
          <div className="text-sm text-gray-500 font-medium">Merchant:</div>
                <select
                  value={selectedMerchant}
                  onChange={(e) => {
                    const code = e.target.value;
                    setSelectedMerchant(code);
                    sessionStorage.setItem("code", code);
                    window.location.reload();
                  }}
                  className="bg-white border border-gray-300 rounded-xl px-4 py-2 min-w-[200px] text-sm focus:ring-2 focus:ring-blue-500"
                >
                  {merchants.map((m) => (
                    <option key={m.Code} value={m.Code}>
                      {m.Name}
                    </option>
                  ))}
                </select>
                </div>
              )}


              <div className="relative profile-dropdown">
                <button
                  onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center shadow-sm">
                    <span className="text-white font-semibold text-sm">AD</span>
                  </div>
                  <div className="hidden sm:block text-left">
                    <p className="text-sm font-semibold text-gray-900">
                      {firstName}
                    </p>
                    <p className="text-xs text-gray-500">Administrator</p>
                  </div>
                  <i
                    className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                      isProfileDropdownOpen ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>

                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <p className="text-sm font-semibold text-gray-900">
                        Admin User
                      </p>
                      <p className="text-xs text-gray-500">admin@gmail.com</p>
                    </div>

                    <Link
                      to="/settings"
                      className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={() => setIsProfileDropdownOpen(false)}
                    >
                      <i className="ri-user-line text-gray-400"></i>
                      View Profile
                    </Link>

                    <button
                      onClick={() => {
                        setIsProfileDropdownOpen(false);
                        navigate('/settings');
                        setTimeout(() => {
                          const event = new CustomEvent('setActiveTab', {
                            detail: 'portal',
                          });
                          window.dispatchEvent(event);
                        }, 100);
                      }}
                      className="flex items-center gap-3 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                    >
                      <i className="ri-global-line text-gray-400"></i>
                      Customer Portal
                    </button>

                    <button
                      onClick={() => {
                        setIsProfileDropdownOpen(false);
                        navigate('/settings');
                        setTimeout(() => {
                          const event = new CustomEvent('setActiveTab', {
                            detail: 'help',
                          });
                          window.dispatchEvent(event);
                        }, 100);
                      }}
                      className="flex items-center gap-3 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                    >
                      <i className="ri-question-line text-gray-400"></i>
                      Help & Support
                    </button>

                    <hr className="my-2" />

                    <button
                      onClick={handleLogout}
                      className="flex items-center gap-3 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                    >
                      <i className="ri-logout-box-line text-red-400"></i>
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Page content */}
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
